import React, { useState } from 'react';
import { App, Tabs, Typography } from 'antd';
import { FileImageOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { useParams } from 'react-router';
import GenerateImage from '../../../components/CreativeStudio/GenerateImage';
import { PLAN } from '../../../graphql/queries/plans';
import { useQuery } from '@apollo/client';
import { Loader } from '../../../components/UI/Loader';

const { Text } = Typography;

const iconStyle = css`
  font-size: 20px;
`;

const contentContainerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CreativeStudio: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState<string>('1');
  const { message } = App.useApp();

  const {
    loading,
    data,
    refetch: refreshPlanData,
  } = useQuery(PLAN, {
    variables: { id },
    fetchPolicy: 'network-only',
    onError: error => {
      message.error(error.message);
    },
  });

  if (loading) return <Loader />;
  const { plan } = data;

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: '1',
      label: (
        <>
          <FileImageOutlined className={iconStyle} /> Images
        </>
      ),
      children: (
        <GenerateImage photos={plan.photos} planId={id} refreshPlanData={refreshPlanData} />
      ),
    },
    {
      key: '2',
      label: (
        <>
          <VideoCameraOutlined className={iconStyle} /> Video
        </>
      ),
      children: (
        <div className={contentContainerStyle}>
          <Text>Video content</Text>
        </div>
      ),
    },
  ];

  return (
    <Tabs
      defaultActiveKey="1"
      activeKey={activeTab}
      onChange={handleTabChange}
      centered
      items={items}
      animated={{ inkBar: true, tabPane: true }}
      destroyInactiveTabPane
    />
  );
};

export default CreativeStudio;
